/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell';
import * as moment from 'moment';
import * as tsx from 'vue-tsx-support';
import { FontAwesomeIcon } from '@/components/Icon';
import { NotificationStore, SiteSettingsStore, UserStore } from '@/store';
export default tsx.component({
    name: 'notification-bell',
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    data() {
        return {
            running: true,
        };
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    destroyed() {
        this.running = false;
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    created() {
        // Delay initial notification to give preference to initial load of the
        // page.
        this.scheduleNotification(1, moment.duration(3, 'seconds'));
    },
    methods: {
        /** Loads either the full notifications or checks for unread. */
        async loadNotifications() {
            if (!this.running) {
                return;
            }
            let mult = 1;
            try {
                if (UserStore.loggedIn()) {
                    if (this.$getRootInstance().$loadFullNotifications) {
                        await NotificationStore.dispatchLoadNotifications();
                    }
                    else {
                        await NotificationStore.dispatchLoadHasUnread();
                    }
                }
            }
            catch (e) {
                // eslint-disable-next-line
                console.log('Loading notifications went wrong', e);
                mult = 2;
            }
            this.scheduleNotification(mult);
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        scheduleNotification(mult, base) {
            const duration = base ??
                SiteSettingsStore.getSetting()('NOTIFICATION_POLL_TIME', UserStore.tenantId());
            setTimeout(() => {
                this.loadNotifications();
            }, duration.asMilliseconds() * mult);
        },
    },
    computed: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        hasUnread() {
            return NotificationStore.getHasUnreadNotifications();
        },
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render() {
        return (<FontAwesomeIcon icon={faBell} class={{
                'notification-bell': true,
                shown: this.hasUnread,
            }} scale={0.75} style={{ opacity: this.hasUnread ? 1 : 0 }} v-b-popover_top_hover_window={this.hasUnread ? 'You have unread notifications' : ''}/>);
    },
});
